import React, { Component, Suspense } from 'react';
import PropTypes from 'prop-types';
import { injectIntl } from 'react-intl';
import { connect } from 'react-redux';
import { BlockSearchStruttureBodySkeleton } from 'uniba-volto-persone/components';
import { bannerStrutture } from 'uniba-volto-persone/theme/images';
import Skeleton from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css';

const BlockSearchStruttureBody = React.lazy(() =>
    import('uniba-volto-persone/components').then(module => ({
        default: module.BlockSearchStruttureBody,
    }))
);

class View extends Component {
    /**
      * Property types.
      * @property {Object} propTypes Property types.
      * @static
      */
    static propTypes = {
        data: PropTypes.objectOf(PropTypes.any).isRequired,
        id: PropTypes.string.isRequired,
        content: PropTypes.shape({
            '@id': PropTypes.string,
            title: PropTypes.string,
            description: PropTypes.string,
        }),
        intl: PropTypes.object.isRequired,
    };

    state = {
        hideBanner: false,
        imageLoaded: false,
    };

    handleInputChange = (value) => {
        this.setState({ hideBanner: value.length > 0 });
    };

    handleImageLoad = () => {
        this.setState({ imageLoaded: true });
    };

    /**
     * Default properties.
     * @property {Object} defaultProps Default properties.
     * @static
     */
    static defaultProps = {
        content: null,
    };

    /**
      * Component will mount
      * @method componentDidMount
      * @returns {undefined}
      */
    componentDidMount() {
    }

    /**
      * Render method.
      * @method render
      * @returns {string} Markup for the component.
      */
    render() {
        const { intl } = this.props;
        const { hideBanner } = this.state;
        const intl_label = intl.formatMessage({ id: 'struttureBannerLabel' });
        return (
            <div className="block full-width search-strutture">
                <div className={`position-relative banner-wrapper ${hideBanner ? 'collapse-up' : ''}`}>
                    {!this.state.imageLoaded && (
                        <Skeleton
                            height={293}
                            style={{ width: '100%' }}
                            baseColor="#e0e0e0"
                            highlightColor="#f5f5f5"
                        />
                    )}
                    <img
                        src={bannerStrutture}
                        alt={`${intl_label} - banner`}
                        aria-hidden="true"
                        loading="eager"
                        decoding="async"
                        fetchpriority="high"
                        width="1920"
                        height="293"
                        onLoad={this.handleImageLoad}
                        style={{
                            width: '100%',
                            height: 'auto',
                            display: this.state.imageLoaded ? 'block' : 'none',
                        }}
                    />
                    <div
                        className="centered page-title fw-bold text-primary"
                    >
                        {intl_label}
                    </div>
                </div>
                <Suspense fallback={<BlockSearchStruttureBodySkeleton />}>
                    <BlockSearchStruttureBody
                        content={this.props.content_fetched || this.props.content}
                        data={this.props.data}
                        id={this.props.id}
                        onSearchInputChange={this.handleInputChange}
                    />
                </Suspense>
            </div>
        );
    }
}

export default connect(
    (state, ownProps) => ({
        content_fetched: state.content.subrequests[ownProps.id]?.data,
    })
)(injectIntl(View));